import Joi from '@hapi/joi'

export const collectionTypeSchemaObject = {
     productID: Joi.number().invalid(0).required().label("Product Name").messages({
         "any.invalid": `Product Name cannot have invalid characters`,
         "any.required": `Product Name characters`
    }),
    collectionTypeCode: Joi.string().required().invalid("00").min(2).max(2).label("Collection Type Code").regex(/^\w+(?:\s+\w+)*$/).messages({
        "string.empty": `Collection Type Code`,
        "string.pattern.base": `Collection Type Code cannot have invalid characters`,
        "string.min": `Please enter {#limit} digit number`,
        "string.max": `Please enter {#limit} digit number`,
        "any.invalid": `Cannot have 00 as Collection Type Code`
    }),
    collectionTypeName: Joi.string().required().label("Collection Type Name").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Collection Type Name required`,
        "string.pattern.base": `Please enter valid Collection Type Name`
    }),
    //operationEntityLocation: Joi.string().allow("", null).label("Estate Location"),
    isActive: Joi.boolean().label("Active")
}